// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .dashboard-container {
  min-height: 100vh;
  background-color: #f7fafc;
} */

.dashboard-header {
  background: #f8f8f8;
  padding: 20px 40px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-header h1 {
  margin: 0;
  color: #1a202c;
  font-size: 24px;
}

.logout-button {
  background-color: #e53e3e;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.logout-button:hover {
  background-color: #c53030;
}
.dashboard-content {
  margin-top: 30px;
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  max-width: 100%;
}

@media (max-width: 480px) {
  .dashboard-content {
    grid-template-columns: 1fr;
    gap: 15px;
    margin-top: 20px;
  }
  
  .dashboard-header {
    padding: 15px 20px;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
  
  .logout-button {
    width: 100%;
    text-align: center;
  }
}


.welcome-card {
  background: #f8f8f8;
  padding: 40px;
  border-radius: 12px;
  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */
  text-align: center;
  margin-top: 20px;
}

.welcome-card h2 {
  margin: 0 0 16px 0;
  color: #1a202c;
  font-size: 28px;
}

.welcome-card p {
  margin: 0;
  color: #718096;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/features/dashboard/DashboardPage.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;EACE,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;;AAGA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB","sourcesContent":["/* .dashboard-container {\n  min-height: 100vh;\n  background-color: #f7fafc;\n} */\n\n.dashboard-header {\n  background: #f8f8f8;\n  padding: 20px 40px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.dashboard-header h1 {\n  margin: 0;\n  color: #1a202c;\n  font-size: 24px;\n}\n\n.logout-button {\n  background-color: #e53e3e;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.logout-button:hover {\n  background-color: #c53030;\n}\n.dashboard-content {\n  margin-top: 30px;\n  display: grid;\n  gap: 20px;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  max-width: 100%;\n}\n\n@media (max-width: 480px) {\n  .dashboard-content {\n    grid-template-columns: 1fr;\n    gap: 15px;\n    margin-top: 20px;\n  }\n  \n  .dashboard-header {\n    padding: 15px 20px;\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-start;\n  }\n  \n  .logout-button {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n\n.welcome-card {\n  background: #f8f8f8;\n  padding: 40px;\n  border-radius: 12px;\n  /* box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); */\n  text-align: center;\n  margin-top: 20px;\n}\n\n.welcome-card h2 {\n  margin: 0 0 16px 0;\n  color: #1a202c;\n  font-size: 28px;\n}\n\n.welcome-card p {\n  margin: 0;\n  color: #718096;\n  font-size: 16px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
